<template><button :type="type" :class="['lu-button', 'lu-button--' + variant, 'lu-button--' + size]" :disabled="disabled || loading" :aria-busy="loading || undefined" @click="handleClick"><UiSpinner v-if="loading" /><slot /></button></template>
<script>
import UiSpinner from './UiSpinner.vue';
export default { name: 'UiButton', components: { UiSpinner }, props: {
  variant: { type: String, default: 'primary', validator: v => ['primary','secondary','outline','ghost'].includes(v) },
  size: { type: String, default: 'md', validator: v => ['sm','md','lg'].includes(v) },
  type: { type: String, default: 'button' }, loading: Boolean, disabled: Boolean
}, emits: ['click'], methods: { handleClick(e) { if (!this.disabled && !this.loading) this.$emit('click', e); } } };
</script>
